import upsertThreadContentItem from '@/lib/threads/upsertThreadContentItem.js';
import ensureThreadContentItem from '@/redux/reducers/pieveReducer/ensureThreadContentItem.js';

const applyThreadAppConnectionClearSuccess = ({ state, payload }) => {
  const threadId = String(payload?.data?.threadId || payload?.meta?.threadId || '').trim();
  const appId = String(payload?.data?.appId || payload?.meta?.appId || '').trim();
  const ensuredThread = ensureThreadContentItem({ state, threadId });

  if (!threadId || !appId || !ensuredThread) {
    return state;
  }

  const currentSelections = Array.isArray(ensuredThread.threadContentItem?.appConnections) ? ensuredThread.threadContentItem.appConnections : [];

  return {
    ...state,
    threadContent: upsertThreadContentItem(ensuredThread.threadContent, {
      ...ensuredThread.threadContentItem,
      threadId,
      appConnections: currentSelections.filter((item) => item?.appId !== appId)
    })
  };
};

export default applyThreadAppConnectionClearSuccess;
